import { __decorate } from "tslib";
import Searchbar from "@/components/Searchbar.vue";
import NavbarUser from "@/components/NavbarUser.vue";
import CustomerModal from "@/Pages/People/CustomerModal.vue";
import SmartAppointment from "@/Pages/Appointments/Smart.vue";
import Modals from "@/components/Modals.vue";
import { Component, Mixins } from "vue-property-decorator";
import ModalMixin from "@/mixins/modal-mixin";
import PendingExamsBar from "./Widgets/PendingExamsBar.vue";
let TopBarComponent = class TopBarComponent extends Mixins(ModalMixin) {
    searchActive = false;
    customerDefaults = {
        avatar_id: null,
        avatar: {},
        gender: "female",
        allow_general_sms: true,
        allow_promo_sms: true
    };
    appointmentDefaults = {
        appointmentAt: this.$moment().add(1, "day"),
        services: [{}]
    };
    browserNetwork = false;
    get meta() {
        return this.$store.state.meta;
    }
    created() {
        window.addEventListener("online", this.updateOnlineStatus);
        window.addEventListener("offline", this.updateOnlineStatus);
        window.addEventListener('keyup', (event) => {
            if (!event.target)
                return;
            if (['BODY', 'A'].indexOf(event.target.tagName) < 0)
                return;
            this.searchActive = false;
            if (event.ctrlKey || event.shiftKey)
                return;
            if ([27, 13, 20, 16, 9, 17, 18, 91, 8, 46, 37, 38, 39, 40, 175].includes(event.keyCode)) {
                this.searchActive = false;
            }
        });
    }
    destroyed() {
        window.removeEventListener("online", this.updateOnlineStatus);
        window.removeEventListener("offline", this.updateOnlineStatus);
    }
    newAppointment() {
        const appointment = {
            model: this.appointmentDefaults,
            _id: 'temp'
        };
        const { Appointment } = this.$FeathersVuex;
        new Appointment(appointment);
        this.openModal({ id: 'AppointmentFastModal' });
    }
    updateOnlineStatus() {
        let status = navigator.onLine ? "online" : "offline";
        this.browserNetwork = status === "online" ? false : true;
    }
};
TopBarComponent = __decorate([
    Component({
        name: 'topbar',
        components: {
            Modals,
            Searchbar,
            NavbarUser,
            CustomerModal,
            SmartAppointment,
            PendingExamsBar,
        },
    })
], TopBarComponent);
export default TopBarComponent;
;
